import * as Actions from '../actions';

export default function entriesReducer(state = {}, action) {
	switch (action.type) {
		case Actions.SEARCH_ENTRIES_COMPLETE:
			return action.entries;
		default: 
			return state;
	}
}
